import { render } from "./PressReview.vue?vue&type=template&id=4818b99e&scoped=true"
import script from "./PressReview.vue?vue&type=script&lang=js"
export * from "./PressReview.vue?vue&type=script&lang=js"

import "./PressReview.vue?vue&type=style&index=0&id=4818b99e&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_BO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4818b99e"]])

export default __exports__